import { Button } from './Button.jsx';

function Arrows(props) {
    let config = {};
    if (props.config) {
        config = { ...props.config };
    }
    config.style = 'underline';
    return (
        <Button
            config={config}
            form={props.form}
            link={props.link}
            name={props.name}
            renderAsLink={props.renderAsLink}
            type={props.type}
            onClick={props.onClick}
            disabled={props.disabled}>
            <span className="btn__text">{props.display}</span>
            <span className="i i--darrows">&gt;&gt;</span>
        </Button>
    )
}

export default Arrows;